export const CONFIGURATION = {
    DEFAULT_DATE_FORMAT: 'Y MMM DD',
    EMAIL_VALIDATION_PATTERN: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
    DEFAULT_MONTH_FORMAT: 'MMM'
};
